import React, { useState } from 'react'
import { useRef } from 'react';
import Header from '../../master/SideBar';
import Nav from '../../master/NavBar';
import Footer from '../footer';
const data = {
    classes: ['10-A', '10-B', '11-A'],
    batches: {
        '10-A': ['Batch 1', 'Batch 2'],
        '10-B': ['Batch 1'],
        '11-A': ['Batch Alpha', 'Batch Beta'],
    },
    students: {
        '10-A|Batch 1': ['Aman', 'Priya', 'Rahul'],
        '10-A|Batch 2': ['Ravi', 'Sneha'],
        '10-B|Batch 1': ['Vijay', 'Meera'],
        '11-A|Batch Alpha': ['Arjun', 'Neha'],
        '11-A|Batch Beta': ['Rohan', 'Simran'],
    },
};
export default function CertificateReceipt() {
    const [cls, setCls] = useState('');
    const [bat, setBat] = useState('');
    const [studentOpts, setStudentOpts] = useState([]);
    const [students, setStudents] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [show, setShow] = useState(false);
    const containerRef = useRef();

    const onClassChange = e => {
        setCls(e.target.value);
        setBat('');
        setStudents([]);
        setStudentOpts([]);
        setShow(false);
    };

    const onBatchChange = e => {
        const b = e.target.value;
        setBat(b);
        setStudents([]);
        setShow(false);
        setStudentOpts(data.students[`${cls}|${b}`] || []);
    };

    const handleSubmit = () => {
        if (cls && bat && (students.length || selectAll)) {
            setShow(true);
            setTimeout(() => containerRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
        } else alert('Please select class, batch and student(s).');
    };

    const handlePrint = () => window.print();
    const list = selectAll ? studentOpts : students;
    return (
        <> <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <Header />
                <div className="layout-page">
                    <Nav />
                    <div className="content-wrapper">
                        <div className="container-fluid py-4">
                            <div className="card p-4 no-print mb-4">
                                <h3 className="fw-bold mb-4 text-primary">Receipt Generator</h3>

                                <div className="row g-4">
                                    {/* Class */}
                                    <div className="col-md-4">
                                        <label className="form-label fw-semibold">Class</label>
                                        <select className="form-select" value={cls} onChange={onClassChange}>
                                            <option value="">Select Class</option>
                                            {data.classes.map(c => <option key={c} value={c}>{c}</option>)}
                                        </select>
                                    </div>

                                    {/* Batch */}
                                    <div className="col-md-4">
                                        <label className="form-label fw-semibold">Batch</label>
                                        <select className="form-select" value={bat} onChange={onBatchChange} disabled={!cls}>
                                            <option value="">Select Batch</option>
                                            {(data.batches[cls] || []).map(b => <option key={b} value={b}>{b}</option>)}
                                        </select>
                                    </div>

                                    {/* Students */}
                                    <div className="col-md-4">
                                        <label className="form-label fw-semibold">Students</label>
                                        <select
                                            className="form-select"
                                            multiple
                                            disabled={!bat}
                                            value={students}
                                            onChange={e => setStudents([...e.target.selectedOptions].map(o => o.value))}
                                            style={{ height: '100px' }}
                                        >
                                            <option value="All">All Students</option>
                                            {studentOpts.map(s => <option key={s} value={s}>{s}</option>)}
                                        </select>
                                    </div>
                                </div>

                                <div className="form-check mt-3">
                                    <input
                                        id="all"
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={selectAll}
                                        onChange={e => { setSelectAll(e.target.checked); if (e.target.checked) setStudents([]); }}
                                    />
                                    <label className="form-check-label" htmlFor="all">Generate for all students</label>
                                </div>

                                <div className="text-end mt-4">
                                    <button className="btn btn-success px-4" onClick={handleSubmit}>Generate</button>
                                </div>
                            </div>

                            {show && (
                                <div ref={containerRef} className="px-2">
                                    <div className="d-flex justify-content-between align-items-center mb-3 no-print">
                                        <h5 className="text-primary">Generated Receipts</h5>
                                        <button className="btn btn-warning" onClick={handlePrint}>Print All</button>
                                    </div>

                                    <div className="row g-4">
                                        {list.map((name, i) => (
                                            <div key={i} className="col-12">
                                                <div className="receipt-card card border border-success shadow-sm p-4 mb-4">
                                                    <h5 className="fw-bold">{name}</h5>
                                                    <p><strong>Class:</strong> {cls}</p>
                                                    <p><strong>Batch:</strong> {bat}</p>
                                                    <p><strong>Date:</strong> {new Date().toLocaleDateString()}</p>
                                                    <hr />
                                                    <p className="text-success"><strong>Amount Paid:</strong> ₹500</p>
                                                    <p className="text-muted small">Thank you for your payment.</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                        <Footer />
                        <div className="content-backdrop fade"></div>
                    </div>
                </div>
                <div className="layout-overlay layout-menu-toggle"></div>
                <div className="drag-target"></div>
            </div>
        </div>
        </>
    )
}
